import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/correct-circle-green.svg'


const _withScopeId = n => (_pushScopeId("data-v-eec4656e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "puzzle-dropdowns" }
const _hoisted_2 = { class: "puzzle-dropdown-title" }
const _hoisted_3 = { class: "text-md title" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "correct-circle-green"
}

import { puzzle, puzzleCorrectAnswers } from '@/data/puzzle'
import PuzzleVideoCard from './PuzzleVideoCard.vue'
import Dropdown from '../Dropdown.vue'
import { computed } from 'vue'
import { PuzzleUserAnswer } from '@/types/Puzzle'
import { useStorePuzzle } from '@/stores/puzzle'
import { DropdownValue } from '@/types/Dropdown'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentUserAnswers: null
  },
  setup(__props: any) {

const props = __props as {
  currentUserAnswers: PuzzleUserAnswer[]
}



const puzzleStore = useStorePuzzle()

function getCurrentValue(videoId: number) {
  const stepId = props.currentUserAnswers.find(
    (currentUserAnswer) => currentUserAnswer.videoId === videoId
  )?.stepId

  if (!stepId) {
    return null
  }

  return `Step ${stepId}`
}

const dropdownValues = computed(() => {
  let values: DropdownValue[] = []

  puzzleCorrectAnswers.forEach((puzzleCorrectAnswer) => {
    const isUsed = props.currentUserAnswers.some(
      (currentUserAnswer) =>
        currentUserAnswer.stepId === puzzleCorrectAnswer.stepId
    )

    values.push({
      id: puzzleCorrectAnswer.stepId,
      name: `Step ${puzzleCorrectAnswer.stepId}`,
      isUsed: isUsed,
    })
  })

  return values
})

function saveUserAnswers(stepId: number, videoId: number) {
  const userAnswers = props.currentUserAnswers

  const userAnswersStepIndex = userAnswers.findIndex(
    (userAnswer) => userAnswer.stepId === stepId
  )

  if (userAnswersStepIndex !== -1) {
    userAnswers.splice(userAnswersStepIndex, 1)
  }

  const userAnswersVideoIndex = userAnswers.findIndex(
    (userAnswer) => userAnswer.videoId === videoId
  )

  if (userAnswersVideoIndex !== -1) {
    userAnswers.splice(userAnswersVideoIndex, 1)
  }

  userAnswers.push({
    stepId,
    videoId,
  })
}

function getJustificationBorder(videoId: number) {
  if (!puzzleStore.showJustification) {
    return
  }

  return isAnswerCorrect(videoId)
    ? 'puzzle-step-placeholder-correct'
    : 'puzzle-step-placeholder-wrong'
}

function isAnswerCorrect(videoId: number) {
  const userAnswer = props.currentUserAnswers.find(
    (userAnswer) => userAnswer.videoId === videoId
  )

  const isCorrect = puzzleCorrectAnswers.some(
    (puzzleCorrectAnswer) =>
      puzzleCorrectAnswer.stepId === userAnswer?.stepId &&
      puzzleCorrectAnswer.videoId === userAnswer?.videoId
  )

  return isCorrect
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(puzzle), (puzzleVideo) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "puzzle-dropdown",
        key: puzzleVideo.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(`Extract ${puzzleVideo.id}`), 1),
          (
            isAnswerCorrect(puzzleVideo.id) && _unref(puzzleStore).showJustification
          )
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["video-card", getJustificationBorder(puzzleVideo.id)])
        }, [
          _createVNode(PuzzleVideoCard, {
            "puzzle-video": puzzleVideo,
            draggable: true
          }, null, 8, ["puzzle-video"])
        ], 2),
        _createVNode(Dropdown, {
          class: "dropdown",
          "current-value": getCurrentValue(puzzleVideo.id),
          placeholder: "Step",
          values: _unref(dropdownValues),
          disabled: _unref(puzzleStore).showJustification,
          onSelectItem: (stepId) => saveUserAnswers(stepId, puzzleVideo.id)
        }, null, 8, ["current-value", "values", "disabled", "onSelectItem"])
      ]))
    }), 128))
  ]))
}
}

})